import { render, staticRenderFns } from "./wb-menu-btn.vue?vue&type=template&id=7affad6a&scoped=true"
import script from "./wb-menu-btn.vue?vue&type=script&lang=js"
export * from "./wb-menu-btn.vue?vue&type=script&lang=js"
import style0 from "./wb-menu-btn.vue?vue&type=style&index=0&id=7affad6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7affad6a",
  null
  
)

export default component.exports